module.exports = __webpack_public_path__ + "static/media/tw.56afa37d.svg";